// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Cockpit_wrapper__CqLjN"};